<template>
  <div>
    <v-row class="ma-2">
      <v-col cols="9" class="float-left" id="leftMenuC">       
        <v-btn class="mr-2" :color="settings.options.color" :loading="loading" dark @click.stop="GetData()"><v-icon>mdi-sync-circle</v-icon></v-btn>
		    <v-btn class="mr-2" color="success" dark @click.stop="getVirtualHallData()">GetData</v-btn>
        <v-btn-toggle v-model="activeHall" mandatory  :active-class="settings.options.color+' white--text'" class="d-inline mx-4" v-if="vh">
          <template v-for="(h,hi) in vh[0].halls">
            <v-btn style="height:36px" :key="hi" dark :value="h">{{h.hallName}}</v-btn>
          </template>          
        </v-btn-toggle>
        <v-btn-toggle v-model="mealFilter" mandatory  :active-class="settings.options.color+' white--text'" v-if="meals">
          <v-btn 
            v-for="(m,m2) in meals" :key="m2"
            v-bind="attrs" v-on="on"
            elevation="5"
            height="40"
            class="px-3 blue-grey darken-2"
            :value="m.mealId"    
          >
          {{m.name}}
          </v-btn>
        </v-btn-toggle>
        <v-btn-toggle v-model="activeSlot" mandatory :active-class="settings.options.color+' white--text'" class="background" v-if="vh">  
          <v-btn 
            class="px-3 blue-grey darken-2"
            height="40"
            :value="c.slotId"
            v-for="(c,c1) in vh" :key="c1"
            :loading="loading"
          >
          {{c.name}}</v-btn>
        </v-btn-toggle>
        <div>{{slctdTbls.map(t=>t.tableName)}}</div> 
      </v-col>      
      <v-col cols="3" id="leftMenuD">
        <!--<v-slider v-model="sliderValue" min="0" max="100" @change="handleSliderChange"></v-slider>-->
        <v-slider min="0" max="100" @change="handleSliderChange"></v-slider>
      </v-col>       
    </v-row> 

    <v-row class="text-center">
      <v-col cols="12" class="d-flex justify-center">
        <div class="warp-container">
          <div class="wrap">
            <div>
              <canvas id="mycanvas" @drop="dropCard" @dragover="allowDropCard"></canvas>
            </div>
          </div>
          <div class="wrap2">
            <div>
              <canvas id="mycanvas2"></canvas>
            </div>
          </div>

          <div class="warp-container"
            v-if="isHandleAnchor()"
            :style="{ zIndex: 5 }">

            <div class="top-anchor anchor"
              @mousedown="handleAnchors"
              @touchstart="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(0, -' + selDivStyle.hH + 'px)',
              }"
            ></div>
            <div class="bottom-anchor anchor"
              @mousedown="handleAnchors"
              @touchstart="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(0, ' + selDivStyle.hH + 'px)',
              }"
            ></div>
            <div class="right-anchor anchor"
              @mousedown="handleAnchors"
              @touchstart="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + (selDivStyle.hW) + 'px, 0)',
              }"
            ></div>
            <div class="left-anchor anchor"
              @mousedown="handleAnchors"
              @touchstart="handleAnchors"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + selDivStyle.hW + 'px, 0)',
              }"
            ></div>
            <!-- Anchor Transform -->
            <div class="top-left-rotate rotate"
              @mousedown="handleRotate"
              @touchstart="handleRotate"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + (selDivStyle.hW + 18) + 'px, -' + (selDivStyle.hH + 18) + 'px)',
              }"
            ></div>
            <div class="top-right-rotate rotate"
              @mousedown="handleRotate"
              @touchstart="handleRotate"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + (selDivStyle.hW + 18) + 'px, -' + (selDivStyle.hH + 18) + 'px)',
              }"
            ></div>
            <div class="bottom-right-rotate rotate"
              @mousedown="handleRotate"
              @touchstart="handleRotate"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(-' + (selDivStyle.hW + 18) + 'px, ' + (selDivStyle.hH + 18) + 'px)',
              }"
            ></div>
            <div class="bottom-left-rotate rotate"
              @mousedown="handleRotate"
              @touchstart="handleRotate"
              :style="{
                left: selDivStyle.fX + 'px',
                top: selDivStyle.fY + 'px',
                transform: 'rotate(' + selDivStyle.imgAngle + 'rad) translate(' + (selDivStyle.hW + 18) + 'px, ' + (selDivStyle.hH + 18) + 'px)',
              }"
            ></div>
          </div>
          
        </div>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialogNew"
      max-width="600"
      style="overflow:hidden"
    >
      <v-card>
        <v-card-title class="text-h5">
          New Hall
          <v-spacer></v-spacer>
          <v-btn float icon>
            <v-icon color="success">mdi-content-save</v-icon>
          </v-btn>
          <v-btn float icon @click="dialogNew = false">
            <v-icon color="info">mdi-close</v-icon>
          </v-btn>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
          <v-row>
            <v-col cols="6">
              <v-text-field
                  v-model="hall.name"
                  counter="25"
                  label="Hall Name"
                  outlined
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="d-flex justify-center">
              <v-switch v-model="hall.location" :label="hall.location?'Indoor':'Outdoor'"></v-switch>
            </v-col>
            <v-col cols="6">
                <v-text-field
                  v-model="hall.width"
                  type="number"
                  label="Hall Width"
                  outlined
                  hint="in cm"
                ></v-text-field>              
            </v-col>
            <v-col cols="6">
                <v-text-field
                  v-model="hall.height"
                  type="number"
                  label="Hall Height"
                  outlined
                  hint="in cm"
                ></v-text-field>
            </v-col>
            <v-col cols="6">
                <v-text-field
                  v-model="hall.tableWidth"
                  type="number"
                  label="Table Width"
                  outlined
                  hint="in cm"
                ></v-text-field>              
            </v-col>
            <v-col cols="6">
                <v-text-field
                  v-model="hall.tableHeight"
                  type="number"
                  label="Table Height"
                  outlined
                  hint="in cm"
                ></v-text-field>
            </v-col>
          </v-row>            
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogSave"
      max-width="600"
      style="overflow:hidden"
    >
      <v-card>
        <v-card-title class="text-h5">
          getVHall
          <v-spacer></v-spacer>
          <v-btn float icon>
            <v-icon color="success">mdi-content-save</v-icon>
          </v-btn>
          <v-btn float icon @click="dialogSave=false">
            <v-icon color="info">mdi-close</v-icon>
          </v-btn>            
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
          {{JSON.stringify(this.vh)}}
        </v-card-text>
      </v-card>
    </v-dialog> 
	</div>
</template>

<script>
  import Square from "./Square_out";
  import {DIRECTION} from "./Constant";
  import { mapGetters } from "vuex";
  export default {
    name: 'CanvasHallData',

    created(){
      console.log(1357,this.settings)
      //this.$vuetify.theme.dark = this.settings.options.darkTheme;
      //this.$store.dispatch("scheme/setDarkTheme", true);
      console.log(276,this.settings);
      if (this.settings&&this.settings.brand==' ')
      {
        this.$router.push('/auth/login').catch(() => {});
      }
      else
      {
        this.GetData(0)
      }
    },
    watch:{
      activeHall(newVal,oldVal)
      {
        console.log(289,this.activeSlot,newVal.hallId)
        this.initTables(this.activeSlot,newVal.hallId)
      },
      activeSlot(newVal,oldVal)
      {
        console.log(294,newVal,this.activeHall)
        this.initTables(newVal,this.activeHall.hallId)        
      }
    },
    computed : {
      ...mapGetters(["settings"])
    },
    methods:{
      /*
    async loadFonts() {
        const font = new FontFace("mdi", "url(https://cdn.jsdelivr.net/npm/@mdi/font/fonts/materialdesignicons-webfont.woff2?v=7.3.67)", {
          style: "normal",
          weight: "400",
          stretch: "condensed",
        });
        // wait for font to be loaded
        await font.load();
        // add font to document
        document.fonts.add(font);
        // enable font with CSS class
        //document.body.classList.add("fonts-loaded");
      }, 
      */     
      async GetData(row)
      {
        console.log(344,row,this.date);
        console.log(308,this.settings,this.slots,this.meals,this.halls,this.currentValues)
        this.loading=true;
        this.dialog_connectionError=false;
        //this.bookings_previous=this.bookings?JSON.parse(JSON.stringify(this.bookings)):null;
        //try{
            const payload=JSON.stringify({"action":"Canvas_Out_get","mealId": "61DDBA14AD96920BE27845D9C8BDCFAE9392D11E","date": "2023-10-28"});
            const res = await this.$http.post('/manage/manage.php', payload );
            console.log(351,res)
            this.loading= false;
            switch (res.data.errorid)
            {
              case '0':
                  document.title = this.settings.brand+' | '+this.page;
                  sessionStorage.setItem('jwt', res.data.jwt);
                  console.log(657,res.data.payloads)
                  //this.expired=res.data.payloads.expired;
                  this.vh=res.data.payloads;
                  console.log(662,this.vh[0].halls,this.vh[0].halls[0].hallId);
                  this.initTables(0,this.vh[0].halls[0].hallId)
                  //return true;
              break;
              case '0007':
                var responsePayload=JSON.parse(res.data.payload)
                this.errorTitle=responsePayload.errorInfo[2];
                this.errorMessage=responsePayload.xdebug_message;
                console.log(1834,res.data.payload,this.errorMessage,this.errorTitle)
                this.dialog_connectionError=true;
              break;
              case '0006':
                  this.$router.push('/auth/login').catch(() => {});
              break;
            }/*  
        } catch(e)
        {
          this.loading= false;
          this.dialog_connectionError=true;
        }*/
      },      
      getOffsetCoords(mouse, rect) {
        return {
            x: mouse.x - rect.x,
            y: mouse.y - rect.y
        }
      },
      cursorInRect(mouseX, mouseY, rectX, rectY, rectW, rectH, angle = 0) {

        let realRect = this.getRealMouseRect(rectX, rectY, rectW, rectH, angle);

        // let x = rectX + this.camera.x;
        // let y = rectY + this.camera.y;

        // let xLine = mouseX > x && mouseX < x + rectW
        // let yLine = mouseY > y && mouseY < y + rectH
        let xLine = mouseX > realRect.leftEdgeX && mouseX < realRect.rightEdgeX;
        let yLine = mouseY > realRect.topEdgeY && mouseY < realRect.bottomEdgeY;

        return xLine && yLine
      },

      getRealMouseRect(x, y, width, height, rotation) {
        // Define the rectangle properties
        // const x = 200; // x-coordinate of the rectangle
        // const y = 200; // y-coordinate of the rectangle
        // const width = 100; // width of the rectangle
        // const height = 50; // height of the rectangle
        // const rotation = 45; // rotation angle in degrees

        // Convert the rotation angle to radians
        const angleInRadians = rotation;

        // Calculate the center point of the rectangle
        const centerX = x + width / 2;
        const centerY = y + height / 2;

        // Calculate the coordinates of the four corners
        const topLeftX = Math.cos(angleInRadians) * (x - centerX) - Math.sin(angleInRadians) * (y - centerY) + centerX;
        const topLeftY = Math.sin(angleInRadians) * (x - centerX) + Math.cos(angleInRadians) * (y - centerY) + centerY;

        const topRightX = Math.cos(angleInRadians) * (x + width - centerX) - Math.sin(angleInRadians) * (y - centerY) + centerX;
        const topRightY = Math.sin(angleInRadians) * (x + width - centerX) + Math.cos(angleInRadians) * (y - centerY) + centerY;

        const bottomLeftX = Math.cos(angleInRadians) * (x - centerX) - Math.sin(angleInRadians) * (y + height - centerY) + centerX;
        const bottomLeftY = Math.sin(angleInRadians) * (x - centerX) + Math.cos(angleInRadians) * (y + height - centerY) + centerY;

        const bottomRightX = Math.cos(angleInRadians) * (x + width - centerX) - Math.sin(angleInRadians) * (y + height - centerY) + centerX;
        const bottomRightY = Math.sin(angleInRadians) * (x + width - centerX) + Math.cos(angleInRadians) * (y + height - centerY) + centerY;

        // Calculate the x and y coordinates of the edges
        const leftEdgeXTemp = Math.min(topLeftX, bottomLeftX);
        const rightEdgeXTemp = Math.max(topRightX, bottomRightX);
        const topEdgeYTemp = Math.min(topLeftY, topRightY);
        const bottomEdgeYTemp = Math.max(bottomLeftY, bottomRightY);

        const leftEdgeX = Math.min(leftEdgeXTemp, rightEdgeXTemp);
        const rightEdgeX = Math.max(leftEdgeXTemp, rightEdgeXTemp);
        const topEdgeY = Math.min(topEdgeYTemp, bottomEdgeYTemp);
        const bottomEdgeY = Math.max(topEdgeYTemp, bottomEdgeYTemp);

        return {
          topLeftX,
          topLeftY,
          topRightX,
          topRightY,
          bottomLeftX,
          bottomLeftY,
          bottomRightX,
          bottomRightY,
          leftEdgeX,
          rightEdgeX,
          topEdgeY,
          bottomEdgeY,
        }
      },

      handleScroll(event) {
        event.preventDefault(); // Prevent default scroll behavior

        const zoomSpeed = 0.1; // Adjust this value to control the zoom speed
        const scrollDelta = Math.sign(event.deltaY); // Get the scroll direction (1 for zoom in, -1 for zoom out)

        // Calculate the new zoom level
        this.zoomLevel -= scrollDelta * zoomSpeed;

        // Limit the zoom level to a specific range if desired
        // For example, you can use:
        this.zoomLevel = Math.max(0.5, Math.min(this.zoomLevel, 8));

        //   // Apply the zoom level to the canvas
        //   ctx2.clearRect(0, 0, canvas.width, canvas.height);
        //   ctx2.scale(zoomLevel, zoomLevel);

        // Redraw your canvas content here
        // ...
        this.drawBG(this.ctx2)

        // Reset the canvas scale to avoid cumulative scaling
          //   ctx2.setTransform(1, 0, 0, 1, 0, 0);
      },
      checkCloseEnough(p1, p2) {
          console.log(29,this.closeEnough)
          return Math.abs(p1 - p2) < this.closeEnough;
      },
      mouseUp() {
        this.dragTL = this.dragTR = this.dragBL = this.dragBR = false;
      },
      mouseDown(e,mouse) {
        //let mouse = getMouseCoords(canvas,this)
        console.log(41, e, mouse,this.dragTL,this.dragTR,this.dragBL,this.dragBR,this.mouseX,this.mouseY)
      },

      drawBG (context){
          context.clearRect(0, 0, this.canvas.width, this.canvas.height);
          context.scale(this.zoomLevel, this.zoomLevel);

          context.save()

          context.fillStyle = 'white'
          context.fillRect(0, 0, this.w / this.zoomLevel, this.h / this.zoomLevel)
          context.lineWidth = 0.3;
          context.strokeStyle = 'lightgray'
          context.fillStyle = 'black'
          console.log('width : ', this.w, 'canvas : ', this.canvas.width)
          for (let i = 1; i < this.w / this.zoomLevel; i++) {
              context.beginPath()
              if (i % 10 === 0) {
                  context.moveTo(i, 0);
                  context.lineTo(i, this.h / this.zoomLevel)
                  context.moveTo(i, 0);
              }
              context.closePath()
              context.stroke()
          }

          for (let i = 1; i < this.h / this.zoomLevel; i++) {
              context.beginPath()
              if (i % 10 === 0) {
                  context.moveTo(0, i)
                  context.lineTo(this.w / this.zoomLevel, i)
                  context.moveTo(0, i)
              }
              context.closePath()
              context.stroke()
          }


          context.lineWidth = 1
          context.strokeStyle = 'gray'

          context.beginPath()
          for (let i = 50; i < this.w / this.zoomLevel; i += 10) {
              if ((i - this.camera.x) % 50 === 0) {
                  context.moveTo(i, 0)
                  context.lineTo(i, 30)
                  context.fillText(` ${i - this.camera.x}`, i, 30)
              } else {
                  context.moveTo(i, 0)
                  context.lineTo(i, 10)
              }

          }
          context.closePath()
          context.stroke()

          context.beginPath()
          for (let i = 50 ; i < this.h / this.zoomLevel; i += 10) {
              if ((i - this.camera.y) % 50 === 0) {
                  context.moveTo(0, i)
                  context.lineTo(30, i)
                  context.fillText(` ${i - this.camera.y}`, 30, i)
              } else {
                  context.moveTo(0, i)
                  context.lineTo(10, i)
              }

          }
          context.closePath()
          context.stroke()
          context.restore()

          context.setTransform(1, 0, 0, 1, 0, 0);
      },
      getMouseCoords(canvas, event) {
        let canvasCoords = canvas.getBoundingClientRect()
        return {
            x: (event.clientX - canvasCoords.left) / this.zoomLevel,
            y: (event.clientY - canvasCoords.top) / this.zoomLevel
        }
      },
      getIt(type = '') {
          let json = [];
          if(type == 'tables') {
            this.prtcls.forEach(e => {
                json.push({
                    "active":true,
                    "tableId": e.tableId,
                    "tableName": e.tableName,
                    "width": e.w,
                    "height": e.h,
                    "shape": e.shape,
                    "x": e.x,
                    "y": e.y
                });
              })
          } else {
            this.prtcls.forEach(e => {
              json.push({
                  name: e.table,
                  xPos: e.x,
                  yPos: e.y
              })
            })
          }

          return json;
      },
	  
      getSelectedData() {
        let json = [];


        this.prtcls.forEach(e => {
          if(e.resize) {
            json.push({
              "active":true,
              "tableId": e.tableId,
              "tableName": e.tableName,
              "width": e.w,
              "height": e.h,
              "shape": e.shape,
              "x": e.x,
              "y": e.y
            });
            //this.slctdTbls.push(e.tableName)
          }
        })

        return json
      },
      setShape(type = 'rect') {
          this.prtcls.forEach(e => {
              if(e.resize) {
                  if(type == 'color') {
                      e.color = document.getElementById('color').value;
                  } else {
                      e.shape = type;
                      if(type == 'round') {
                          e.h = e.w;
                      }
                  }
              }
          })
      },
      allowDropCard(ev) {
          ev.preventDefault();
      },

      dropCard(ev) {
          ev.preventDefault();
          let id = ev.dataTransfer.getData("card");
          let name = ev.dataTransfer.getData("cardName");
          let type = ev.dataTransfer.getData("cardType");
          let repeatable = ev.dataTransfer.getData("repeatable");
          // let json = {...this.defaultParelData};


          console.log(id, !repeatable, repeatable)

          if(id == '') return;
          if(repeatable == 0) {
            this.hideTable(id);
          }

          let canvasCoords = this.canvas.getBoundingClientRect()

          let json = this.tables.filter(t => t.tableId == id);
          if(json.length == 0) {
            json = this.archElements.filter(a => a.elementId == id)[0];
            json['tableId'] = json['elementId'];
            json['tableName'] = json['elementName'];
          } else {
            json = json[0]
          }

          console.log(json)

          json['tableId'] = id;
          json['tableName'] = name;
          json['shape'] = type;
          json['x'] = (Math.round((event.clientX - canvasCoords.left) / 10) * 10) / this.zoomLevel;
          json['y'] = (Math.round((event.clientY - canvasCoords.top) / 10) * 10) / this.zoomLevel;

          let newPrtcls = new Square(json);
          this.prtcls.push(newPrtcls)
      },

      hideTable(id, val = 1) {            //val = 1 : HIDE, 0 : SHOW
        let index = this.tables.findIndex(t => t.tableId == id);
        if(index == -1) {
          index = this.archElements.findIndex(a => a.elementId == id);
          let t = [...this.archElements];
          t[index]['hidden'] = val;
          this.archElements = [...t];
        } else {
          let t = [...this.tables];
          t[index]['hidden'] = val;
          this.tables = [...t];
        }
      },

      getVirtualHallData() {
        let tables = this.getIt('tables');
        this.vh[0]['tables'] = tables;
        console.log("Virtual Hall Json Data :  ", this.vh)
		    console.log("Select Data Json : ", this.getSelectedData())				  
      },

      isHandleAnchor() {
        let isAnchor = false;
        // this.prtcls.forEach(e => {
        //   if(e.resize) {
        //     isAnchor = true;
        //   }
        // })
        return isAnchor;
      },

      SetCamera() {
        this.isRotate = !this.isRotate;
      },

      SetFlipX() {
        this.prtcls.forEach((p) => {
          if(p.resize) {
            p.flipX *= -1;
          }
        })
      },

      SetFlipY() {
        this.prtcls.forEach((p) => {
          if(p.resize) {
            p.flipY *= -1;
          }
        })
      },

      DelTable() {
        let tableId = "";
        let index = -1;
        this.prtcls.forEach((p, i) => {
          if(p.resize) {
            tableId = p.tableId;
            index = i;
          }
        })
        if(index != -1) {
          let p = [...this.prtcls];
          p = p.filter((t, i) => i !== index);
          this.prtcls = [...p];
        }

        this.hideTable(tableId, 0)
      },

      SetColor(e) {
        this.prtcls.forEach(p => {
          if(p.resize) {
            p.color = e.target.value;
          }
        })
      },

      initTables(slot=0,hallId = null) {

          //let json = this.vh[hallIdx]['tables'];
          //this.prtcls = new Array(json.length).fill().map((a,idx) => new Square(json[idx]))
		delete this.prtcls;
          console.log(714,slot,hallId,this.vh)
          let json = (this.vh[slot]['tables']).filter(f=>f.hallId==hallId);
          //console.log(716,json)
          this.prtcls = new Array(json.length).fill().map((a,idx) => new Square(json[idx]))
          //console.log(this.prtcls,JSON.stringify(this.prtcls))

      },
      animate () {
          this.ctx.clearRect(0, 0, this.w, this.ctx.canvas.height)
          this.ctx.scale(this.zoomLevel, this.zoomLevel);

          this.ctx.fillStyle = 'white'
          let aa = [...this.prtcls];
          aa.reverse().forEach(e => {
              e.select = true
              e.camera = {...this.camera};
              e.draw(this.ctx)
              if(e.resize) {
                this.drawDragAnchor(e.x, e.y, e.w, e.h, e.angle);
              }
          })
          this.ctx.setTransform(1, 0, 0, 1, 0, 0);
          window.requestAnimationFrame(this.animate)
      },

      handleSelect(e) {
        let mouse = this.getMouseCoords(this.canvas, e);
		    let isSelect = false;							 
        this.prtcls.forEach(e => {
          if (this.cursorInRect(mouse.x, mouse.y, e.x, e.y, e.w, e.h, e.angle)) {
              e.resize = e.resize==true?false:true
			        isSelect = e.resize
              if (e.resize)
              {
                this.slctdTbls.push(e)
                e.color2=e.color;
                e.color='#9c27b0';
              }
              else
              {
                e.color=e.color2;
                this.slctdTbls=this.slctdTbls.filter(s=>s.tableId!==e.tableId)
              }
          }
        })

		    /*
        if(!isSelect) {
          this.prtcls.forEach(e => {
              e.resize = false
          })
        }*/
      },

      handleRotate(){
        console.log("----set rotate")

        this.isRotate = true;
      },

      handleAnchors(event){
        if(event.toElement != undefined) {
          this.scale_direction = event.toElement.className.replace("-anchor anchor", "");
        } else {
          this.scale_direction = event.currentTarget.className.replace("-anchor anchor", "");
        }

        console.log("----set direction", this.scale_direction)
        this.isScale = true;
      },

      drawSelection(){
        let w = 200;
        let h = 100
        const rect = this.canvas.getBoundingClientRect();
        const left = rect.left;
        const top = rect.top;

        this.selDivStyle.imgWidth = w;
        this.selDivStyle.imgHeight = h;
        this.selDivStyle.hW = w / 2;
        this.selDivStyle.hH = h / 2;
        this.selDivStyle.fX = this.camera.x + w + left + this.selDivStyle.hW;
        this.selDivStyle.fY = this.camera.y + h + top + this.selDivStyle.hH;

        console.log(this.canvas, this.canvas.top)
        console.log(this.selDivStyle.fX, this.selDivStyle.fY)
        // Calculate imgAngle based on your requirements
        this.selDivStyle.imgAngle = Math.PI / 4; // Example angle of 45 degrees
      },

      drawDragAnchor(x, y, w, h, angle){

        const rect = this.canvas.getBoundingClientRect();
        const left = rect.left;
        const top = rect.top;

        w = w * this.zoomLevel;
        h = h * this.zoomLevel

        this.selDivStyle.imgWidth = w;
        this.selDivStyle.imgHeight = h;
        this.selDivStyle.hW = w / 2;
        this.selDivStyle.hH = h / 2;
        this.selDivStyle.fX = ( this.camera.x + x ) * this.zoomLevel + this.selDivStyle.hW + left;
        this.selDivStyle.fY = ( this.camera.y + y ) * this.zoomLevel + this.selDivStyle.hH  + top;

        // Calculate imgAngle based on your requirements
        this.selDivStyle.imgAngle = angle; // Example angle of 45 degrees
      },

      rotate(e, mouse){

        var imageCenterX = e.x + (e.w / 2);
        var imageCenterY = e.y + (e.h / 2);

        var a = { x: mouse.x, y: mouse.y };
        var b = { x: imageCenterX, y: imageCenterY };
        var c = { x: this.startPos.x, y: this.startPos.y };

        var dir = this.ccw(a, b, c);

        var radians = this.getAngle(a, b, c);

        let diff = Math.PI / 18;

        radians = Math.round(radians / diff) * diff;

        e.angle = dir == -1 ? -radians + this.startPos.originAngle : radians + this.startPos.originAngle;
        
      },
      
      scale(e, diff){
		
        let dx = diff.x;
        let dy = diff.y;

        // var xs = dx * dx;
        // var ys = dy * dy;		 
        // var distance =  Math.sqrt( xs + ys );

          if(this.scale_direction == DIRECTION.RIGHT){
            e.w = this.startPos.originW + dx;
          }
          if(this.scale_direction == DIRECTION.LEFT){
            e.w = this.startPos.originW - dx;
            e.x = this.startPos.x + dx - this.camera.x;
          }
          if(this.scale_direction == DIRECTION.BOTTOM){
            e.h = this.startPos.originH + dy;
          }
          if(this.scale_direction == DIRECTION.TOP){
            e.h = this.startPos.originH - dy;
            e.y = this.startPos.y + dy - this.camera.y;
          }

      },

      getAngle(a, b, c){
        var AB = Math.sqrt(Math.pow(b.x-a.x,2)+ Math.pow(b.y-a.y,2));    
        var BC = Math.sqrt(Math.pow(b.x-c.x,2)+ Math.pow(b.y-c.y,2)); 
        var AC = Math.sqrt(Math.pow(c.x-a.x,2)+ Math.pow(c.y-a.y,2));
        return Math.acos((BC*BC+AB*AB-AC*AC)/(2*BC*AB));
      },

      ccw(a, b, c) {
        var area2 = (b.x - a.x)*(c.y - a.y) - (b.y - a.y)*(c.x - a.x);
        if (area2 < 0) return -1;
        if (area2 > 0) return +1;
        return 0;
      },

      detectDoubleTap(event) {
        const curTime = new Date().getTime();
        const tapLen = curTime - this.lastTap;

        if (tapLen < 500 && tapLen > 0) {
          // Double tap detected

          this.handleSelect(event);

          console.log('Double tapped!');
        } else {
          // Not a double tap, start a timer
          this.timeout = setTimeout(() => {
            clearTimeout(this.timeout);
          }, 500);
        }

        this.lastTap = curTime;
      },

      handleMouseMove(e) {
        let diff = {
              x : Math.round((e.clientX - this.startPos.x) / 10) * 10,
              y : Math.round((e.clientY - this.startPos.y) / 10) * 10,
          };
          if(e.which == 2) {
            this.camera.x = this.startPos.originX + diff.x;
            this.camera.y = this.startPos.originY + diff.y;
            this.camera.x = Math.min(0, this.camera.x);
            this.camera.y = Math.min(0, this.camera.y);
            this.drawBG(this.ctx2)
          }
        let mouse = this.getMouseCoords(this.canvas, e);
        let arr = this.prtcls.map(e => this.cursorInRect(mouse.x, mouse.y, e.x, e.y, e.w, e.h, e.angle))
        !arr.every(e => e === false) ? this.canvas.classList.add('pointer') : this.canvas.classList.remove('pointer')          
      },

      handleMouseDown(e) {
        console.log("is SCALE: ", this.isScale, " ROTATE: ", this.isRotate)
        if(e.which == 2) {
            console.log("camera move---")
            this.canvas.classList.add('hand');
            this.startPos = {
                  x : e.clientX,
                  y : e.clientY,
                  originX: this.camera.x,
                  originY: this.camera.y
              }
            }

      },

      handleMouseUp(e) {
        if(e.which == 2) {
          this.canvas.classList.remove('hand')
        } else {
          this.prtcls.forEach(e => {
            e.selected = false
          })
        }
        this.isScale = false;
        this.isRotate = false;
      },

      handleTouchStart(event) {
        const touchPoints = Array.from(event.touches);
        if (touchPoints.length === 2) {
          // Calculate the initial distance between two touch points
          const dx = touchPoints[0].clientX - touchPoints[1].clientX;
          const dy = touchPoints[0].clientY - touchPoints[1].clientY;
          this.pinchStartDistance = Math.sqrt(dx * dx + dy * dy);
          this.initialZoom = 1;
        }
      },

      handleTouchMove(event) {
        const touchPoints = Array.from(event.touches);
        console.log("touch - length -----", touchPoints.length)
        if (touchPoints.length === 2) {
          // Calculate the current distance between two touch points
          const dx = touchPoints[0].clientX - touchPoints[1].clientX;
          const dy = touchPoints[0].clientY - touchPoints[1].clientY;
          const pinchCurrentDistance = Math.sqrt(dx * dx + dy * dy);

          // Calculate the zoom factor based on the pinch distance change
          const zoomFactor = pinchCurrentDistance / this.pinchStartDistance;


          const zoomSpeed = 0.1; // Adjust this value to control the zoom speed
          this.zoomLevel -= (zoomFactor > this.initialZoom ? 1 : -1) * zoomSpeed;
          this.zoomLevel = Math.max(0.5, Math.min(this.zoomLevel, 8));
          // Perform the zoom action based on the zoom factor
          if (zoomFactor > this.initialZoom) {
            // Zoom in
            console.log('Zoom in');
          } else {
            // Zoom out
            console.log('Zoom out');
          }
          this.drawBG(this.ctx2)


          // Update the initial zoom for the next touch move event
          this.initialZoom = zoomFactor;
        }
      },

      handleSliderChange(value) {
        // Do something with the new value
        console.log(value)
        this.zoomLevel = 0.5 + 8.5 * value / 100;
        this.drawBG(this.ctx2)
      },
    },

    data() {
      return {
        dialogSave:false,
        dialogNew:false,
        hall:{},
        activeVHall:null,
        leftMenuC:null,
        leftMenuD:null,
		
        closeEnough: 10,
        dragTL: false,
        dragBL: false,
        dragTR: false,
        dragBR: false,
        drag: false,
        mouseX: null,
        mouseY: null,
        widthPercent: 0.95,
        heightPercent: 0.95,
        zoomLevel: 1,
        prtcls: [],
        startPos: {},
        canvas: null,
        canvas2: null,
        ctx: null,
        ctx2: null,
        w: 0,
        h: 0,
        camera: {
          x : 0,
          y : 0
        },
        setting: {
          diff: 10
        },
        isCameraMove: false,
        isRotate: false,
        isScale: false,
        scale_direction: DIRECTION.LEFT,

        lastTap : 0,
        timeout : null,
        pinchStartDistance : 0,
        initialZoom : 1,
        isPressed : false,
        pressTimer : null,

        selDivStyle: { 
          imageUrl: 'path/to/image.jpg',
          imgWidth: 0,
          imgHeight: 0,
          imgAngle: 0,
          hW: 0,
          hH: 0,
          fX: 0,
          fY: 0,
        },
        vh:null,
        mealFilter:null,
        activeSlot:null,
        activeHall:null,
        date:null,
        loading:false,
        slctdTbls:[]
      }
    },

    mounted() {
      this.canvas = document.getElementById('mycanvas')
      this.canvas2 = document.getElementById('mycanvas2')
      this.ctx = this.canvas.getContext('2d')
      this.ctx2 = this.canvas2.getContext('2d')
      this.w = this.canvas.width = this.canvas2.width = window.innerWidth * this.widthPercent;
      this.h = this.canvas.height = this.canvas2.height = window.innerHeight -230;//* this.heightPercent;

      console.log(1249,window.innerWidth, window.innerWidth,this.w,this.h)
      this.leftMenuC=document.getElementById('leftMenuC')
      this.leftMenuD=document.getElementById('leftMenuD')
      console.log(1250,window.innerWidth, window.innerHeight,this.w,this.h)
      console.log(1251,this.leftMenuC,this.leftMenuC.offsetWidth,this.leftMenuC.offsetHeight)
      console.log(1252,this.leftMenuD,this.leftMenuD.offsetWidth,this.leftMenuD.offsetHeight,this.leftMenuD.clientWidth,this.leftMenuD.clientHeight)  

      this.canvas.style.backgroundColor = 'transparent'
      this.canvas2.style.backgroundColor = 'white'

      this.ctx.lineWidth = 2
      this.ctx.textAlign = 'center'
      this.ctx.textBaseline = 'middle'
      this.ctx.font = '10px Arial'
      
      this.drawBG(this.ctx2)

      // let arr = new Array(40).fill('empty').map(() => Math.floor(Math.random() * 100))


      window.addEventListener('resize', () => {
            this.w = this.canvas.width = this.canvas2.width = window.innerWidth * this.widthPercent;
            this.h = this.canvas.height = this.canvas2.height = window.innerHeight -230;//* this.heightPercent;
            this.drawBG(this.ctx2)
      })

      this.canvas.addEventListener('click', e => {
          // let mouse = this.getMouseCoords(this.canvas, e);
          this.handleSelect(e);
          //console.log(JSON.stringify(this.getIt()), e)
          
      })

      this.canvas.addEventListener('dblclick', e => {
        //this.handleSelect(e);

      })

      window.addEventListener('mousemove', e => {
        this.handleMouseMove(e);
      })

      window.addEventListener('mousedown', e => {
        this.handleMouseDown(e);
      })

      window.addEventListener('mouseup', e => {
        this.handleMouseUp(e);
      })


      window.addEventListener('touchstart', (event) => {
        console.log("touch start")
        
        // ADD Keep press Event and select item
        if(!this.isRotate && !this.isScale) {
          this.isPressed = true;
          let that = this;
          this.pressTimer = setTimeout(function() {
            // Your code for "keep pressed" action here
            that.handleSelect(event.touches[0]);
            console.log("Keep pressed action");
          }, 200); // Adjust the duration (in milliseconds) as needed
        }
      });

      // Add an event listener to the touchmove event
      window.addEventListener('touchmove', (event) => {

        this.handleTouchMove(event);
        // Check if there are at least two touch points
        let e = event.touches[0];
        if (event.touches.length >= 2) {       
          console.log(e.clientX)   
          let diff = {
              x : Math.round((e.clientX - this.startPos.x) / 10) * 10,
              y : Math.round((e.clientY - this.startPos.y) / 10) * 10,
          };
          // Handle the two-finger touch movement
          this.camera.x = this.startPos.originX + diff.x;
          this.camera.y = this.startPos.originY + diff.y;
          this.camera.x = Math.min(0, this.camera.x);
          this.camera.y = Math.min(0, this.camera.y);
          this.drawBG(this.ctx2)
        }

        this.handleMouseMove(event.touches[0])

      });
      
      window.addEventListener('touchend', (event) => {
        this.isPressed = false;
        clearTimeout(this.pressTimer);

        event.width = 1;
        this.handleMouseUp(event);
      })

      this.canvas.addEventListener("contextmenu", e => {
          //event.preventDefault();
        console.log(e)
      });

      this.canvas.addEventListener('wheel', this.handleScroll);

      // document.getElementsByClassName("rotate").addEventListener("mousedown", e => {
      //   this.mouseDown(e)
      // })

      //this.initTables()

      this.animate()

      // this.drawSelection();
      //this.loadFonts()

    },

    // Handle functions

}
</script>

<style lang="scss">

  .table-container{
    z-index: 10;
  }


  .arch-container img {
    width: 50px;
    height: 17px;
  }

  .warp-container {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .wrap {
      position: relative;
      z-index: 2;
  }

  .wrap div {
      box-shadow: 2px 2px 6px -2px rgba(0,0,0,0.75);
  }
  .wrap2 {

      position: absolute;
      z-index: 1;
      background-color: 'white'
  }

  #mycanvas {
      display: block;
      box-sizing: border-box;
      border: 1px solid hsl(259, 100%, 65%)
  }
  #mycanvas2 {
      display: block;
      box-sizing: border-box;
  }

  .pointer {
      cursor: pointer;
  }

  .hand {
      cursor: grab;
  }

  /* Line */
  .line-h{
      position: fixed;
      height: 0px;
  }
  .line-v{
      position: fixed;
      width: 0px;
  }
  .top-line{
      border-top: dashed 2px #f700cb;
  }
  .bottom-line{
      border-bottom: dashed 2px #f700cb;
  }
  .right-line{
      border-right: dashed 2px #f700cb;
  }
  .left-line{
      border-left: dashed 2px #f700cb;
  }
  /* Anchor */
  .anchor{
      position: fixed;
      width: 40px;
      height: 40px;
      margin: -20px 0 0 -20px;
      background-color: #36313594;
      opacity: 0.8;
  }
  /* Rotate */
  .rotate{
      position: fixed;
      width: 40px;
      height: 40px;
      margin: -20px 0 0 -20px;
      background-color: blue;
      opacity: 0.5;
  }
</style>